// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Fx from "../fx/fx.jsx";
import * as Pages__ArtistsPage from "../pages/artistsPage.jsx";
import * as $$Promise from "../promise/promise.jsx";
import * as Routes__LayoutRoute from "./layoutRoute.jsx";
import * as Shared__RouterUtils from "../shared/routerUtils.jsx";
import * as Stdlib__Array from "melange/array.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__FetchArtists from "../storeFx/fetchArtists.jsx";
import * as Store__Context from "../store/context.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function loader(param) {
  const store = param.context.store;
  return $$Promise.Monad_syntax.let$star(Fx.runAsync(StoreFx__FetchArtists.make(undefined), {
    store: store
  }).then(function (result) {
    return Promise.resolve(Stdlib__Result.get_ok(result));
  }), (function (param) {
    const state = store.getState();
    return Promise.resolve({
      initialListIds: Stdlib__Option.get(state.artists.listIds)
    });
  }));
}

function Artists$pendingComponent(Props) {
  return JsxRuntime.jsx(Pages__ArtistsPage.make, {
    listIds: Stdlib__Array.init(30, (function (param) {
      
    }))
  });
}

function Artists$component(Props) {
  const match = ReactRouter.getRouteApi("/_layout/").useLoaderData();
  const listIds = Store__Context.useAppStore(function (state) {
    return state.artists.listIds;
  });
  const listIds$1 = Stdlib__Option.value(listIds, match.initialListIds).map(function (id) {
    return id;
  });
  return JsxRuntime.jsx(Pages__ArtistsPage.make, {
    listIds: listIds$1
  });
}

const route = ReactRouter.createRoute({
  beforeLoad: Shared__RouterUtils.requireSubsonicCredentials,
  component: Artists$component,
  getParentRoute: (function (param) {
    return Stdlib__Fun.$$const(Routes__LayoutRoute.route, param);
  }),
  loader: loader,
  path: "/",
  pendingComponent: Artists$pendingComponent
});

const pendingComponent = Artists$pendingComponent;

const component = Artists$component;

export {
  loader,
  pendingComponent,
  component,
  route,
}
/* route Not a pure module */
